import React from 'react';
import { SVGProps } from './types';

const CorporationIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M5.825 5.015h3.331M5.826 7.51h3.33m-3.33 2.495h3.33M9.574 18.322v-4.99H5.41v4.99"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.2"
        d="M12.523 18.332H2.501V1.676c0-.004.004-.008.008-.008h10.006c.005 0 .008.004.008.008v4.995m0 11.661h4.975V6.68a.008.008 0 00-.008-.009h-4.967m0 11.661V6.672"
      />
    </svg>
  );
};

export { CorporationIcon };
